'use client';

/**
 * Mounts global `window.onerror` and `unhandledrejection` listeners once at
 * app start. Phase 0.3b.
 *
 * This component renders nothing — it only runs the installer in a useEffect.
 * Import it from the root layout ONCE; `installClientErrorHooks` is idempotent
 * but mounting this component twice is a code smell.
 */

import { useEffect } from 'react';
import { installClientErrorHooks } from './client-error';

export function InstallClientErrorHooks(): null {
  useEffect(() => {
    installClientErrorHooks();
  }, []);
  return null;
}
